export const Constants = {

    genders: [
        {value: "0", name: "未知"},
        {value: "1", name: "男"},
        {value: "2", name: "女"}
    ],

    gender(value) {
        if ("0" === value) {
            return "未知"
        }
        if ("1" === value) {
            return "男"
        }
        if ("2" === value) {
            return "女"
        }
        return null
    },

    hmtoIdentities: [
        {value: "1", name: "香港同胞"},
        {value: "2", name: "澳门同胞"},
        {value: "3", name: "台湾同胞"},
        {value: "4", name: "海外侨胞"},
        {value: "5", name: "黄埔同学会"},
    ],

    hmtoIdentity(value) {
        return this.hmtoIdentities.find(i => i.value === value + "")?.name ?? null;
    },

    newsEmotions: [
        {value: "0", name: "中性"},
        {value: "-1", name: "负面"},
        {value: "1", name: "正面"},
    ],

    newsEmotion(value) {
        return this.newsEmotions.find(i => i.value === value + "")?.name ?? null;
    }

}